// NPM
import { Link } from "gatsby"
import _ from "lodash"
import React from "react"
import ReactMarkdown from "react-markdown"
import rehypeRaw from "rehype-raw"

// Shared Components
import SidebarLinks from "src/components/Shared/SidebarLinks"

const Methodology = ({
  methodology,
  productSections = [],
  language = "en",
}) => {
  const productSection = productSections.find(s => s.uuid === "productSection")
  const productLogoUrl = _.get(methodology, `productLogo.url`)
  const productName = _.get(methodology, `product.name`)
  const productPath = _.get(methodology, `product.path`)

  const renderProductLogo = () => {
    if (!productLogoUrl) {
      return null
    }

    return (
      <div className="GenericProduct__logo">
        <img src={productLogoUrl} alt={`${productName} logo`} />
      </div>
    )
  }

  const renderProductImage = () => {
    if (!productSection) {
      return null
    }

    const productImage = productSection.media.find(
      m => m.uuid === "productImage",
    )

    if (!productImage) {
      return null
    }

    return (
      <div className="GenericProduct__image">
        <img src={productImage.image.url} alt={productImage.imageAlt} />
      </div>
    )
  }

  const sidebarLinks = productSections
    .filter(s => s.uuid === "sidebarLink")
    .map(s => s.link)
    .map(l => ({
      text: l.text,
      url: l.url,
      page: l.page,
    }))

  return (
    <div className="GenericProduct Methodology">
      <div className="GenericProduct__content">
        {renderProductLogo()}
        <h1 className="GenericProduct__title">{methodology.title}</h1>
        <ReactMarkdown
          className="Description GenericProduct__description Methodology__content"
          children={_.get(methodology, `content.data.content`, "")}
          rehypePlugins={[rehypeRaw]}
        />
        {renderProductImage()}
      </div>
      <div className="GenericProduct__sidebar">
        {renderProductImage()}
        {productSection && (
          <SidebarLinks
            productSection={productSection}
            methodology={null}
            sidebarLinks={sidebarLinks}
            language={language}
            layout="sidebar"
          >
            {productPath && (
              <div className="Methodology__back">
                <li key={`methodology-back-${productPath}`}>
                  <Link to={productPath} className="GenericProduct__link">
                    <span className="icon left-arrow">
                      <img
                        src={
                          require("src/images/icons/arrow-right-white.png")
                            .default
                        }
                      />
                    </span>
                    <span>
                      {language === "en" ? "Back to" : "Retour à"} {productName}
                    </span>
                  </Link>
                </li>
              </div>
            )}
          </SidebarLinks>
        )}
      </div>
    </div>
  )
}

export default Methodology
